export { default } from './BottomNavigationAction';